
import { useContext, useMemo } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./SkimPile.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import { PumpContext } from "../context/PumpContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";

import { trackPageVisit } from "../competency/PageTracker";




function SkimPile() {

        useEffect(() => {
  
    trackPageVisit("SkimPile");
  
  }, []);

  
  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};


   const {  valves, toggleValve, transmitters} = useContext(WellContext);

  
    const [FIC_2908, setFIC_2908] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2908")) || 0;
            setFIC_2908(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

    const [PT_2908, setPT_2908] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_2908")) || 0;
            setPT_2908(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

    const FIC_2915 = Number(FIC_2908 || 0);

    const PT_2914 = PT_2908;

    const PT_2933 =  0.3;

    const FIC_2914 = 21.23;

    const FIC_2913 = FIC_2914 + FIC_2915;

    const PT_2911 =  0.3;

    const FIC_2911 = 21.23;

    const isXV2910Open = valves?.XV_2910 === false;

    const FIC_2916 = isXV2910Open ? 49.99 : 0;

    const PT_2915 = isXV2910Open ? 0.48 : 0.03;


    // ================= PUMP P-2910 STATE =================
const { pumpData } = useContext(PumpContext);

const isP2910On = pumpData?.["P-2910"]?.running ?? false;


// ================= TARGET VALUES =================
const targetFlow = isP2910On ? 21.23 : 0;     // adjust max flow
const targetPressure = isP2910On ? 0.6 : 0; // adjust max pressure


// ================= STATES =================
const [FIC_2912, setFIC_2912] = useState(
  Number(localStorage.getItem("FIC_2912")) || 0
);

const [PT_2912, setPT_2912] = useState(
  Number(localStorage.getItem("PT_2912")) || 0
);


// ================= SMOOTH RESPONSE =================
useEffect(() => {
  const interval = setInterval(() => {

    // FLOW RESPONSE
    setFIC_2912(prev => {
      const error = targetFlow - prev;
      const gain = isP2910On ? 0.18 : 0.12; // faster up, slower decay
      const next = prev + error * gain;

      return Math.abs(next) < 0.01 ? 0 : Number(next.toFixed(2));
    });

    // PRESSURE RESPONSE
    setPT_2912(prev => {
      const error = targetPressure - prev;
      const gain = isP2910On ? 0.20 : 0.10; // pressure reacts slightly faster
      const next = prev + error * gain;

      return Math.abs(next) < 0.005 ? 0 : Number(next.toFixed(3));
    });

  }, 100); // fast DCS scan (no lag)

  return () => clearInterval(interval);

}, [targetFlow, targetPressure, isP2910On]);


// ================= SAVE TO LOCAL STORAGE =================
useEffect(() => {
  localStorage.setItem("FIC_2912", FIC_2912);
}, [FIC_2912]); 

useEffect(() => {
  localStorage.setItem("PT_2912", PT_2912);
}, [PT_2912]);



    useEffect(() => {
  localStorage.setItem("FIC_2916", FIC_2916);
}, [FIC_2916]);
     

     


  return (
    <div className="SkimPile-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "236px",
        color: "white",
        background: "rgba(39, 18, 233, 0.5)",
        padding: "2px 340px"
      }}>
        SKIM PILE
      </h2>






       {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}



      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2910 */}
      <Valve
        className="XV-2910"
        tag="XV_2910"
        x={732}
        y={420}
        isClosed={valves.XV_2910}
        toggle={toggleValve}
      />


    

      
          {/* ================= TRANSMITTERS ================= */}

           <Transmitter
          tag="FIC-2915"
          value={[FIC_2915]}
          x={1027}
          y={258}
          unit="LPM"
          max={50}
          HH={48}
          H={45}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF TREATED WATER SKIM PILE FILTER FROM H2S STRIPPER"
        />
        <Transmitter
          tag="FIC-2914"
          value={[FIC_2914]}
          x={1027}
          y={186}
          unit="LPM"
          max={50}
          HH={48}
          H={45}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF TREATED WATER SKIM PILE FILTER FROM OILY WATER TANK"
        />
        <Transmitter
          tag="FIC-2913"
          value={[FIC_2913]}
          x={719}
          y={186}
          unit="LPM"
          max={50}
          HH={48}
          H={45}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF TREATED WATER TO SKIM PILE AFTER THE FILTER"
        />
        <Transmitter
          tag="FIC-2911"
          value={[FIC_2911]}
          x={202}
          y={86}
          unit="LPM"
          max={50}
          HH={48}
          H={45}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF PRODUCED WATER FROM FLARE K. O. DRUM TO SKIM PILE"
        />

        <Transmitter
          tag="PT-2914"
          value={PT_2914}
          x={1108}
          y={258}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF TREATED WATER SKIM PILE FILTER FROM H2S STRIPPER"
        />
        <Transmitter
          tag="PT-2933"
          value={PT_2933}
          x={1108}
          y={186}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF TREATED WATER SKIM PILE FILTER FROM OILY WATER TANK"
        />


        <Transmitter
          tag="PT-2911"
          value={PT_2911}
          x={310}
          y={86}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF PRODUCED WATER FROM FLARE K. O. DRUM TO SKIM PILE"
        />

        <Transmitter
          tag="PT-2912"
          value={PT_2912}
          x={295}
          y={191}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF RECOVERED CRUDE OIL TO OILY WATER TANK"
        />

         <Transmitter
          tag="FIC-2912"
          value={[FIC_2912]}
          x={202}
          y={191}
          unit="LPM"
          max={50}
          HH={48}
          H={45}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF RECOVERED CRUDE OIL TO OILY WATER TANK"
        />
        <Transmitter
          tag="PT-2915"
          value={PT_2915}
          x={990}
          y={422}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF RECOVERED WATER TO SETTLEMENT TANK"
        />

         <Transmitter
          tag="FIC-2916"
          value={[FIC_2916]}
          x={910}
          y={422}
          unit="LPM"
          max={50}
          HH={48}
          H={45}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF RECOVERED WATER TO SETTLEMENT TANK"
        />



          
    <LevelTransmitterIndicator
      tag="LT_2911"
      totalLevel={10000}
      inflows={[(FIC_2911+FIC_2913)*0.3]}
      outflows={[FIC_2912]}
      responseFactor={0.05}
      columnX={525}
      columnY={270}
      columnWidth={30}
      columnHeight={128}
      textX={605}
      textY={290}
      showFlow={true}
    />
          
    <LevelTransmitterIndicator
      tag="LT_2912"
      totalLevel={50000}
      inflows={[(FIC_2911+FIC_2913)*0.7]}
      outflows={[FIC_2916]}
      responseFactor={0.05}
      columnX={525}
      columnY={443}
      columnWidth={30}
      columnHeight={108}
      textX={605}
      textY={480}
      showFlow={true}
    />


    
    <Pump
      tag="P-2910"
      x={458}
      y={230}
      rpm={1800}
      bladeCount={pumpData?.["P-2910"]?.bladeCount || 3}
      size={pumpData?.["P-2910"]?.size || 37}
      onClick={openPumpPanel}
    />

   






    </div>
  );
}

export default SkimPile;